@if (adminForm) {
  <div class="dialog-root">
    <h2 mat-dialog-title>{{ "admin.add_admin" | transloco}}</h2>

    <mat-dialog-content class="column" [formGroup]="adminForm">
      <mat-form-field hideRequiredMarker="true">
        <mat-label>{{ "admin.admin_type.label" | transloco }}</mat-label>
        <mat-select formControlName="adminType">
          @for (adminType of adminTypes; track $index) {
            <mat-option [value]="adminType">{{ adminType | adminType }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field hideRequiredMarker="true">
        <mat-label>{{ "form.label.first_name" | transloco }}</mat-label>
        <input formControlName="firstName" matInput type="text" />
      </mat-form-field>

      <mat-form-field hideRequiredMarker="true">
        <mat-label>{{ "form.label.last_name" | transloco }}</mat-label>
        <input formControlName="lastName" matInput type="text" />
      </mat-form-field>

      <mat-form-field hideRequiredMarker="true">
        <mat-label>{{"form.label.email" | transloco}}</mat-label>
        <input formControlName="email" matInput type="text" />
      </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions>
      <button (click)="close()" mat-button type="button">{{ "button.cancel" | transloco }}</button>
      <button (click)="add()" mat-flat-button type="submit">{{ "admin.add_admin" | transloco }}</button>
    </mat-dialog-actions>
  </div>
}
